<template>
    <div class="card-product-list">
        <el-table :data="tableData" style="width: 100%"
                  show-summary sum-text="合计" :summary-method="tableTotalEvent">
            <el-table-column prop="name" label="包含项目" width="300">
                <template slot-scope="scope">
                    {{scope.row.name}}
                    <el-tag type="danger" effect="dark" size="mini" v-if="scope.row.tag">{{scope.row.tag}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="price" label="单价" width="300">
                <template slot-scope="scope">
                    ¥ {{scope.row.price}}
                </template>
            </el-table-column>
            <el-table-column prop="num" label="次数" width="300">
                <template slot-scope="scope">
                    <span v-if="scope.row.num > 0">{{scope.row.num}}次</span>
                    <span v-else>不限</span>
                </template>
            </el-table-column>
            <el-table-column prop="valid_day" label="有效期">
                <template slot-scope="scope">
                    <span v-if="scope.row.valid_day > 0">{{scope.row.valid_day}}天</span>
                    <span v-else>永久有效</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    export default {
        name: "CardProductList",
        props: {
            cardId: {
                type: [String, Number],
                default: 0
            }
        },
        data: () => ({
            tableData: [
                // {
                //     name: "次卡",
                //     tag: "",
                //     num: "11",
                //     valid_day: "0"
                // }, {
                //     name: "洗剪吹",
                //     tag: "赠",
                //     num: "3",
                //     valid_day: "0"
                // }
            ],
            originData: {},
        }),
        mounted: function () {

        },
        methods: {
            //表格统计
            tableTotalEvent: function (rowData) {
                const {columns, data} = rowData;
                let sums = [];
                if(this.originData.count_type === "1" || this.originData.count_type === "3"){
                    sums = ["共计", "", 0, ""];
                    data.forEach( v => {
                        if(!obj.isNull(v.num) && !isNaN(v.num)) {
                            sums[2] += Number(v.num);
                        }
                    });
                    sums[2] += "次";
                    return sums;
                }else
                    return ["", "", "", ""];
            },
            //加载次卡数据
            loadCardData: function () {
                obj.postData("card/get_card_product_info", {id: this.cardId}, res => {
                    if(res.errcode === 0){
                         this.tableData = res.data.product;
                         this.originData = res.data;
                    }
                });
            }
        },
        watch: {
            cardId: function (val) {
                this.loadCardData();
            }
        }

    }
</script>

<style scoped>

</style>
